module.exports = __webpack_public_path__ + "static/footer-background-5025fc6c588942f98518aaca04d01211.png";